/** Themenschlüssel der anonymen Mikrobi-Auswertung (Spiegel von supabase/functions/mikrobi-chat/topics.ts). */
export const TOPIC_LABELS: Record<string, string> = {
  reizdarm_sibo: "Reizdarm / SIBO",
  ced: "CED (Morbus Crohn, Colitis)",
  blase_ic: "Blase / interstitielle Zystitis",
  prostatitis_cpps: "Prostatitis / Beckenschmerz",
  endometriose_hormone: "Endometriose / Hormone",
  haut: "Haut",
  unvertraeglichkeiten: "Nahrungsmittelunverträglichkeiten",
  mikrobiom: "Mikrobiom allgemein",
  bakteriophagen: "Bakteriophagen / Keimresistenz",
  diagnostik: "Diagnostik / Labor",
  ernaehrung: "Ernährung / Low FODMAP",
  termin: "Termin & Ablauf",
  preise: "Preise & Kosten",
  ueber_isabella: "Über Isabella",
  motivation: "Zweifel & Motivation",
  sonstiges: "Sonstiges",
};
